export enum CurrentDeployStatus {
  Running = 'running',
  Exited = 'exited'
}
